import React from 'react';
import chroma from 'chroma-js';

import Graphic from '../Graphic';
import { useTheme } from '../../../hooks/index';

const Logs = props => {
  const { primary } = useTheme();

  return (
    <Graphic
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 140 145"
      preserveAspectRatio="xMidYMid meet"
      fill="none"
      {...props}>
      <path
        fill="#F3F3F4"
        d="M70.994 145c28.166 0 51-1.567 51-3.5s-22.834-3.5-51-3.5c-28.167 0-51 1.567-51 3.5s22.833 3.5 51 3.5Z"
      />
      <path
        fill="#D9D9D9"
        d="M70.155 139.214c33.775 0 61.155-27.359 61.155-61.107S103.93 17 70.155 17C36.38 17 9 44.358 9 78.107c0 33.748 27.38 61.107 61.155 61.107Z"
      />
      <path
        fill="#D9D9D9"
        d="M115.003 120.106C103.821 132.331 87.731 140 69.85 140c-15.223 0-29.147-5.558-39.85-14.753v-.637l85.003-4.504Z"
      />
      <path
        fill={primary}
        fillOpacity=".75"
        d="M115.003 120.106C103.821 132.331 87.731 140 69.85 140c-15.223 0-29.147-5.558-39.85-14.753v-.637l85.003-4.504Z"
      />
      <path
        fill="#D9D9D9"
        d="M75.301 139.761a62.197 62.197 0 0 1-6.627.228c.32-.679.346-1.495.003-2.236-.61-1.316-2.153-1.896-3.448-1.296l-5.755 2.667a60.705 60.705 0 0 1-8.19-1.991l11.738-5.439c1.294-.6 1.85-2.153 1.24-3.468-.61-1.315-2.153-1.895-3.447-1.296l-14.064 6.517a2.557 2.557 0 0 0-1.339 1.479 60.966 60.966 0 0 1-8.671-4.647l-2.54-5.482c-1.22-2.63-.108-5.736 2.48-6.935l10.75-4.981a5.143 5.143 0 0 1 1.966-.469 5.139 5.139 0 0 1 1.994.328l11.77 4.423a5.295 5.295 0 0 1 2.935 2.732l9.205 19.866Z"
      />
      <path
        fill={primary}
        fillOpacity=".5"
        d="M75.301 139.761a62.197 62.197 0 0 1-6.627.228c.32-.679.346-1.495.003-2.236-.61-1.316-2.153-1.896-3.448-1.296l-5.755 2.667a60.705 60.705 0 0 1-8.19-1.991l11.738-5.439c1.294-.6 1.85-2.153 1.24-3.468-.61-1.315-2.153-1.895-3.447-1.296l-14.064 6.517a2.557 2.557 0 0 0-1.339 1.479 60.966 60.966 0 0 1-8.671-4.647l-2.54-5.482c-1.22-2.63-.108-5.736 2.48-6.935l10.75-4.981a5.143 5.143 0 0 1 1.966-.469 5.139 5.139 0 0 1 1.994.328l11.77 4.423a5.295 5.295 0 0 1 2.935 2.732l9.205 19.866Z"
      />
      <path
        fill="#D9D9D9"
        d="m51.284 137.133 11.738-5.439c1.294-.6 1.85-2.153 1.24-3.468-.61-1.315-2.153-1.895-3.447-1.296l-14.064 6.517a2.557 2.557 0 0 0-1.339 1.479l5.872 2.207Z"
      />
      <path
        fill={primary}
        fillOpacity=".5"
        d="m51.284 137.133 11.738-5.439c1.294-.6 1.85-2.153 1.24-3.468-.61-1.315-2.153-1.895-3.447-1.296l-14.064 6.517a2.557 2.557 0 0 0-1.339 1.479l5.872 2.207Z"
      />
      <path
        fill="#D9D9D9"
        d="m51.284 137.133 11.738-5.439c1.294-.6 1.85-2.153 1.24-3.468-.61-1.315-2.153-1.895-3.447-1.296l-14.064 6.517a2.557 2.557 0 0 0-1.339 1.479l5.872 2.207ZM68.674 139.989c.32-.679.346-1.495.003-2.236-.61-1.316-2.153-1.896-3.448-1.296l-5.755 2.667 9.2.865Z"
      />
      <path
        fill={primary}
        fillOpacity=".5"
        d="M68.674 139.989c.32-.679.346-1.495.003-2.236-.61-1.316-2.153-1.896-3.448-1.296l-5.755 2.667 9.2.865Z"
      />
      <path
        fill="#D9D9D9"
        d="M68.674 139.989c.32-.679.346-1.495.003-2.236-.61-1.316-2.153-1.896-3.448-1.296l-5.755 2.667 9.2.865Z"
      />
      <path
        fill={primary}
        fillOpacity=".75"
        fillRule="evenodd"
        d="M110.817 124.854c.279-.248.556-.497.83-.748a.5.5 0 1 0-.676-.737c-.54.495-1.089.981-1.646 1.457a.496.496 0 0 0-.186.343.496.496 0 0 0 .467.547.506.506 0 0 0 .368-.13c.283-.241.564-.485.843-.732Zm3.274-4.556a.507.507 0 0 0-.106.555.493.493 0 0 0 .283.268.49.49 0 0 0 .39-.017.5.5 0 0 0 .159-.119 61.766 61.766 0 0 0 4.316-5.089.501.501 0 0 0-.797-.605 60.844 60.844 0 0 1-4.245 5.007Zm-9.417 9.343a.504.504 0 0 0 .209-.32.474.474 0 0 0-.002-.195.487.487 0 0 0-.215-.317.498.498 0 0 0-.377-.07.49.49 0 0 0-.179.076 60.716 60.716 0 0 1-3.7 2.336.499.499 0 0 0 .123.916.5.5 0 0 0 .38-.051 61.929 61.929 0 0 0 3.761-2.375Zm-5.706 3.46a.5.5 0 0 0-.472-.882c-18.15 9.695-39.99 9.416-57.774-.37a.49.49 0 0 0-.38-.042.494.494 0 0 0-.359.424.5.5 0 0 0 .256.494c18.08 9.947 40.278 10.232 58.729.376Zm24.138-25.146a.494.494 0 0 0-.043.38.497.497 0 0 0 .62.342.494.494 0 0 0 .299-.239c9.968-18.084 10.274-40.283.434-58.727a.5.5 0 0 0-.883.47c9.68 18.144 9.379 39.983-.427 57.774Zm-.639-59.687a.501.501 0 0 0 .865-.503 60.76 60.76 0 0 0-2.374-3.762.5.5 0 0 0-.826.564 60.066 60.066 0 0 1 2.335 3.7v.001Zm-89.69 79.612a.492.492 0 0 0 .7-.097.49.49 0 0 0 .098-.37.501.501 0 0 0-.193-.33 60.521 60.521 0 0 1-5.007-4.244.498.498 0 0 0-.686.04.5.5 0 0 0-.001.687 61.529 61.529 0 0 0 5.09 4.314Zm-8.211-7.484a.5.5 0 1 0 .737-.676 61.999 61.999 0 0 1-.7-.776C2.462 93.874 4.83 55.586 29.907 33.401c25.076-22.185 63.367-19.87 85.551 5.16.231.263.46.526.686.79a.503.503 0 0 0 .716.069.502.502 0 0 0 .044-.718 61.894 61.894 0 0 0-.655-.755l-.006-.008-.036-.04-.035-.04a62.576 62.576 0 0 0-3.805-3.926.48.48 0 0 0-.065-.073 61.224 61.224 0 0 0-5.09-4.314.495.495 0 0 0-.128-.071 61.195 61.195 0 0 0-7.187-4.653.496.496 0 0 0-.146-.12c-18.08-9.949-40.278-10.234-58.728-.377a.498.498 0 0 0-.22.237 57.12 57.12 0 0 0-1.407.785.498.498 0 0 0-.318.063 61.549 61.549 0 0 0-3.762 2.375.5.5 0 0 0-.195.262 62.219 62.219 0 0 0-4.8 3.673.498.498 0 0 0-.305.12c-.566.483-1.123.977-1.672 1.48a.5.5 0 0 0-.156.288 62.467 62.467 0 0 0-2.724 2.682.499.499 0 0 0-.29.151 61.682 61.682 0 0 0-4.316 5.089.498.498 0 0 0-.102.308 61.228 61.228 0 0 0-4.513 6.935.499.499 0 0 0-.234.215c-9.97 18.084-10.275 40.282-.434 58.727.025.048.058.09.095.125.302.565.613 1.127.934 1.684.012.047.03.093.055.136a61.3 61.3 0 0 0 2.373 3.763.496.496 0 0 0 .076.087 62.091 62.091 0 0 0 4.71 6.056l.036.04.043.048c.22.25.443.497.669.742Z"
        clipRule="evenodd"
      />
      <path fill="#fff" stroke={primary} d="M1 16h88v85H1V16Z" />
      <path fill="#fff" d="M5.994 21h78v76h-78V21Z" />
      <path
        fill="#D9D9D9"
        d="M19.994 21h-13a1 1 0 0 0-1 1v74a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V22a1 1 0 0 0-1-1ZM82.994 30.214h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.994 39.214h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.994 48.214h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.994 57.213h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.994 66.213h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.994 75.213h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM38.77 21H26.4a.905.905 0 0 0 0 1.81H38.77a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill={primary}
        d="M83.089 21h-5.281a.905.905 0 0 0 0 1.81h5.28a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill="#F3F3F4"
        d="M74.225 21h-5.281a.905.905 0 0 0 0 1.81h5.28a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill="#D9D9D9"
        d="M33.453 24.619h-7.054a.905.905 0 0 0 0 1.81h7.054a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill="#fff"
        d="M89.114 113.213c7.403 0 13.404-5.996 13.404-13.393s-6.001-13.393-13.404-13.393S75.71 92.423 75.71 99.82s6.001 13.393 13.404 13.393Z"
      />
      <path
        fill="url(#a)"
        fillRule="evenodd"
        d="M89.114 113.214c7.403 0 13.404-5.997 13.404-13.394s-6.001-13.393-13.404-13.393S75.71 92.423 75.71 99.82s6.001 13.394 13.404 13.394Zm1.675-18.416a1.675 1.675 0 0 0-3.35 0v3.348h-3.351a1.675 1.675 0 1 0 0 3.348h3.35v3.349a1.674 1.674 0 0 0 1.676 1.676 1.677 1.677 0 0 0 1.676-1.676v-3.349h3.35a1.674 1.674 0 1 0 0-3.348h-3.35l-.001-3.348Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="m85.252 34.304-.133.292 13.375 5.779v.5c5.263 0 9.979-2.34 13.165-6.035l.209-.244-.134-.292c-2.301-5.01-7.364-8.492-13.241-8.492s-10.939 3.481-13.24 8.492ZM120.494 23.5c0 12.15-9.85 22-22 22s-22-9.85-22-22 9.85-22 22-22 22 9.85 22 22Zm-17.669-4.107a6.123 6.123 0 0 0-4.331-10.456 6.125 6.125 0 1 0 4.331 10.456Z"
      />
      <path
        fill={primary}
        fillOpacity=".25"
        d="m85.252 34.304-.133.292 13.375 5.779v.5c5.263 0 9.979-2.34 13.165-6.035l.209-.244-.134-.292c-2.301-5.01-7.364-8.492-13.241-8.492s-10.939 3.481-13.24 8.492ZM120.494 23.5c0 12.15-9.85 22-22 22s-22-9.85-22-22 9.85-22 22-22 22 9.85 22 22Zm-17.669-4.107a6.123 6.123 0 0 0-4.331-10.456 6.125 6.125 0 1 0 4.331 10.456Z"
      />
      <path
        stroke={primary}
        d="m85.252 34.304-.133.292 13.375 5.779v.5c5.263 0 9.979-2.34 13.165-6.035l.209-.244-.134-.292c-2.301-5.01-7.364-8.492-13.241-8.492s-10.939 3.481-13.24 8.492ZM120.494 23.5c0 12.15-9.85 22-22 22s-22-9.85-22-22 9.85-22 22-22 22 9.85 22 22Zm-17.669-4.107a6.123 6.123 0 0 0-4.331-10.456 6.125 6.125 0 1 0 4.331 10.456Z"
      />
      <path
        fill={primary}
        d="M98.493 26.313c-5.674 0-10.563 3.36-12.786 8.2a16.839 16.839 0 0 0 12.787 5.862c5.111 0 9.691-2.272 12.786-5.862-2.223-4.84-7.112-8.2-12.787-8.2Zm5.626-11.25a5.62 5.62 0 0 1-3.473 5.196 5.623 5.623 0 0 1-7.777-5.197 5.625 5.625 0 1 1 11.25.001ZM111.994 26.676c0 1.422.979 2.66 2.36 2.868.984.148 1.979.26 2.984.337a.997.997 0 0 1 .754.445L120.494 34l2.401-3.674a.984.984 0 0 1 .755-.445 41.281 41.281 0 0 0 2.984-.337c1.381-.207 2.36-1.445 2.36-2.87v-5.349c0-1.424-.979-2.662-2.36-2.869a41.406 41.406 0 0 0-6.14-.456 41.45 41.45 0 0 0-6.14.456c-1.381.207-2.36 1.446-2.36 2.87v5.35Z"
      />
      <path
        stroke={primary}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M116.571 22.667h7.846m-7.846 2.666h3.923m-8.5 1.343c0 1.422.979 2.66 2.36 2.868.984.148 1.979.26 2.984.337a.997.997 0 0 1 .754.445L120.494 34l2.401-3.674a.984.984 0 0 1 .755-.445 41.281 41.281 0 0 0 2.984-.337c1.381-.207 2.36-1.445 2.36-2.87v-5.349c0-1.424-.979-2.662-2.36-2.869a41.406 41.406 0 0 0-6.14-.456 41.45 41.45 0 0 0-6.14.456c-1.381.207-2.36 1.446-2.36 2.87v5.35Z"
      />
      <path
        fill="#fff"
        d="M136.994 69.5h-13a1.5 1.5 0 0 0-1.5 1.5v13a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5V71a1.5 1.5 0 0 0-1.5-1.5Z"
      />
      <path
        stroke={primary}
        d="M136.994 69.5h-13a1.5 1.5 0 0 0-1.5 1.5v13a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5V71a1.5 1.5 0 0 0-1.5-1.5Z"
      />
      <path
        stroke={primary}
        strokeLinecap="round"
        d="m128.66 79.5 1.32-1.44m0 0c.249.272.592.44.972.44.759 0 1.375-.672 1.375-1.5s-.616-1.5-1.375-1.5-1.375.672-1.375 1.5c0 .414.154.79.403 1.06Zm4.639-.56c0 2.485-1.847 4.5-4.125 4.5-2.279 0-4.125-2.015-4.125-4.5s1.846-4.5 4.125-4.5c2.278 0 4.125 2.015 4.125 4.5Z"
      />
      <defs>
        <linearGradient
          id="a"
          x1="89.114"
          x2="89.114"
          y1="86.427"
          y2="113.214"
          gradientUnits="userSpaceOnUse">
          <stop stopColor={chroma(primary).brighten(0.5 - 0)} />
          <stop offset="1" stopColor={primary} />
        </linearGradient>
      </defs>
    </Graphic>
  );
};
export default Logs;
